module.exports = __webpack_public_path__ + "static/media/Investor-CHRIS DREES_1646324760810.26012e02.vtt";